import React, { Fragment, useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import clsx from "clsx";

//MUI Components
import Typography from "@mui/material/Typography";
import Collapse from "@mui/material/Collapse";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionActions from "@mui/material/AccordionActions";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";

//MUI Icons
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

//Custom Components
import MapCard from "@/ui/MapCard/MapCard";
import MapCardHeader from "@/ui/MapCard/MapCardHeader";
import MapCardAvatar from "@/ui/MapCard/MapCardAvatar";
import MapCardContent from "@/ui/MapCard/MapCardContent";
import MapCardActions from "@/ui/MapCard/MapCardActions";
import MapCardActionButton from "@/ui/MapCard/MapCardActionButton";
import dataController from "@/lib/dataController";
import MapCardHeaderButtonClose from "@/ui/MapCard/MapCardHeaderButtonClose";
import DialogContext from "@/ui/DialogContext/DialogContext";
import { GridContainer, GridItem } from "@/ui/Grid";
import ModelTable from "@/ui/Table/ModelTable";
// import { dataService } from "@/services/dataService";
import FormContent from "@/components/FormContent";
import UserContext from "@/components/UserContext/UserContext";

// import modelPregled from "Models/pregledi";
// import ImageSlider from "@/components/ImageSlider";

import modelData from "@/models/data";
import modelDKP from "@/models/dkp";
// import modelKB from "@/models/adrese";
// import modelNC from "@/models/nc";
// import modelDKP2 from "@/models/dkp2";
// import modelDKP2Zgrade from "@/models/dkp2zgrade";
import modelPosjednici from "@/models/posjednici";
import modelVlasnici from "@/models/zk_vlasnici";
// import modelRasvjetaMjesta from "@/models/rasvjetna_mjesta";
// import modelLokacije from "@/models/lokacije";
// import modelParkiralista from "@/models/parkiralisna_mjesta";

// import DataDialog from "Views/MapPage/DataDialog";
// import InspectionDialog from "Views/MapPage/InspectionDialog";

//Types
import { DCRecord } from "@/@types/lib/dataController";
import { GFIFeatureType } from "@/services/gsService";
import RenderFeature from "ol/render/Feature";
import { Geometry } from "ol/geom";
import { Feature } from "ol";
import { ICardOverlayData } from "@/@types/views/GIS/map";

export type CardPosition = [number, number];

export type CardOverlayType =
  | "gsinfo"
  | "dkp"
  | "kb"
  | "nc"
  | "dkp2"
  | "dkp2zgrade"
  | "rasvjeta"
  | "lok"
  | "parking"
  | "commentinfo";


export interface GSInfoCardProps {
  featureData: ICardOverlayData;
  onClose: any;
  expandedVlasnici: boolean;
  setExpandedVlasnici: React.Dispatch<React.SetStateAction<boolean>>;
  expandedPosjednici: boolean;
  setExpandedPosjednici: React.Dispatch<React.SetStateAction<boolean>>;
}

function GSInfoCard(props: GSInfoCardProps) {
  const { t } = useTranslation();

  const initialRecod = props.featureData.record
    ? props.featureData.record
    : props.featureData.feature.properties;

  const [record, setRecord] = useState(initialRecod);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [loadStatus, setLoadStatus] = useState({
    isLoading: true,
    isLoaded: false,
  });
  const [imageLoadStatus, setImageLoadStatus] = useState({
    imageLoading: true,
  });
  const [inspections, setInspections] = useState(null);

  const [recordsPosjednici, setRecordsPosjednici] = useState<DCRecord[]>([]);
  const [recordsVlasnici, setRecordsVlasnici] = useState<DCRecord[]>([]);

  const dialogContext = useContext(DialogContext);
  const userContext = useContext(UserContext);

  const {
    featureData,
    onClose,
    expandedPosjednici,
    setExpandedPosjednici,
    expandedVlasnici,
    setExpandedVlasnici,
  } = props;

  const { type } = featureData;

  const getModel = () => {
    switch (type) {
      case "dkp":
        return modelDKP;
      // case "kb":
      //   return modelKB;
      // case "nc":
      //   return modelNC;
      // case "dkp2":
      //   return modelDKP2;
      // case "dkp2zgrade":
      //   return modelDKP2Zgrade;
      // case "rasvjeta":
      //   return modelRasvjetaMjesta;
      // case "lok":
      //   return modelLokacije;
      // case "parking":
      //   return modelParkiralista;
      default:
        return modelData;
    }
  };

  const model = getModel();

  const dc = new dataController(model);
  const dcPosjednici = new dataController(modelPosjednici);
  const dcVlasnici = new dataController(modelVlasnici);

  const faIconClass = "fas fa-info ";

  const recordId = record ? record.id : null;

  const handleRefresh = function () {
    setRefreshCounter(refreshCounter + 1);

    setLoadStatus({ isLoading: true, isLoaded: false });
  };

  const handleTogglePosjednici = function () {
    const newValue = !expandedPosjednici;
    setExpandedPosjednici(newValue);
    if (newValue) {
      setExpandedVlasnici(false);
    }
  };

  const handleToggleVlasnici = function () {
    const newValue = !expandedVlasnici;
    setExpandedVlasnici(newValue);
    if (newValue) {
      setExpandedPosjednici(false);
    }
  };

  const loadPosjedniciDKP2 = () => {
    if (record) {
      dcPosjednici
        .GetData(`data/dkp2/${record.id}/posjednici/`)
        .then((resp) => {
          if (resp.success && Array.isArray(resp.data)) {
            setRecordsPosjednici(resp.data);
          }
        });
    }
  };

  const loadPosjedniciDKP = () => {
    if (record) {
      dcPosjednici.GetData(`data/dkp/${record.id}/posjednici/`).then((resp) => {
        if (resp.success && Array.isArray(resp.data)) {
          setRecordsPosjednici(resp.data);
        }
      });
    }
  };

  const loadVlasniciDKP = () => {
    if (record) {
      dcVlasnici.GetData(`data/dkp/${record.id}/zk-vlasnici/`).then((resp) => {
        if (resp.success && Array.isArray(resp.data)) {
          setRecordsVlasnici(resp.data);
        }
      });
    }
  };

  useEffect(() => {
    if (recordId) {
      if (type === "dkp") {
        loadPosjedniciDKP();
        loadVlasniciDKP();
      }
    }
  }, [recordId]);

  const handleEdit = () => {
    // const model = getModel(type);
    // const dc = new dataController(model);
    // dialogContext.showDialog(DataDialog, {
    //   type: type,
    //   dc: dc,
    //   recordId: record.id,
    //   mode: "update",
    //   form: "edit",
    //   iconClass: faIconClass,
    //   onClose: (result) => handleDataDialogClose(result, record.id)
    // });
  };

  // const handleDataDialogClose = (dialogResult, recordId) => {
  //   if (dialogResult.dataChanged) {
  //     // dataService.getData(recordId).then((result) => {
  //     //   if (result.success) {
  //     //     setRecord(result.data);
  //     //   }
  //     // });
  //   }
  // };

  // const refreshInspections = () => {
  //   // dataService.getPreglediById(record.id).then((resp) => {
  //   //   if (resp) {
  //   //     setInspections(resp);
  //   //   } else {
  //   //     setInspections(null);
  //   //   }
  //   //   setLoadStatus({
  //   //     isLoading: false,
  //   //     isLoaded: true
  //   //   });
  //   // });
  // };

  // useEffect(() => {
  //   refreshInspections();
  // }, [record.id, refreshCounter]);

  useEffect(() => {
    if (featureData) {
      if (featureData.record) {
        setRecord(featureData.record);
      } else if (featureData.feature) {
        setRecord(featureData.feature.properties);
      }
    }
    setRecord;
  }, [featureData]);

  const form = "default";
  const title = record.naziv
    ? record.naziv
    : type
    ? t("map:layer." + type)
    : "Info";

  const hasVlasniciButton = type === "dkp" ? true : false;
  const hasPosjedniciButton = type === "dkp" ? true : false;

  const hasActions = hasVlasniciButton || hasPosjedniciButton;

  // console.log("gsinfocard", props);

  return (
    <Fragment>
      <MapCard
        sx={{
          backgroundColor: "background.default",
          minWidth: "250px",
        }}
      >
        <MapCardHeader
          title={title}
          subheader={t("common.id") + ": " + record.id}
          subheaderTypographyProps={{ color: "initial" }}
          avatar={
            <MapCardAvatar
              ariaLabel="info"
              icon={<i className={faIconClass}></i>}
            />
          }
          action={<MapCardHeaderButtonClose onClick={onClose} />}
        />
        <MapCardContent>
          <GridContainer spacing={0}>
            <GridItem xs={12} container>
              {/* <Form dc={dc} mode="view" form={form} record={record}> */}
              <GridContainer spacing={0}>
                <FormContent
                  // dc={dc}
                  // form={form}
                  fields={dc.getFormFields(form)}
                  fieldNames={dc.getFormFieldsNames(form)}
                  columns={1}
                  mode="simpleView"
                  record={record}
                />
              </GridContainer>
              {/* </Form> */}
            </GridItem>
            {/* <GridItem xs={6}>Image Placeholder</GridItem> */}
          </GridContainer>
        </MapCardContent>
        {hasActions ? (
          <MapCardActions>
            {hasPosjedniciButton ? (
              <MapCardActionButton
                startIcon={<AssignmentIndIcon />}
                endIcon={
                  <ExpandMoreIcon
                    sx={[
                      {
                        transform: "rotate(0deg)",
                        transition: (theme) =>
                          theme.transitions.create("all", {
                            duration: theme.transitions.duration.shortest,
                          }),
                      },
                      expandedPosjednici && {
                        transform: "rotate(180deg)",
                      },
                    ]}
                  />
                }
                onClick={handleTogglePosjednici}
                aria-expanded={expandedPosjednici}
                aria-label="expand"
                disabled={recordsPosjednici.length === 0}
              >
                {t("buttons.posjednici")}
              </MapCardActionButton>
            ) : null}

            {hasVlasniciButton ? (
              <MapCardActionButton
                startIcon={<AssignmentIndIcon />}
                endIcon={
                  <ExpandMoreIcon
                    sx={[
                      {
                        transform: "rotate(0deg)",
                        transition: (theme) =>
                          theme.transitions.create("all", {
                            duration: theme.transitions.duration.shortest,
                          }),
                      },
                      expandedVlasnici && {
                        transform: "rotate(180deg)",
                      },
                    ]}
                  />
                }
                onClick={handleToggleVlasnici}
                aria-expanded={expandedVlasnici}
                aria-label="expand"
                disabled={recordsVlasnici.length === 0}
              >
                {t("buttons.vlasnici")}
              </MapCardActionButton>
            ) : null}
          </MapCardActions>
        ) : null}
        {hasPosjedniciButton || hasVlasniciButton ? (
          <Collapse
            in={expandedPosjednici || expandedVlasnici}
            timeout="auto"
            unmountOnExit
            sx={{ maxHeight: 400, overflowX: "scroll" }}
          >
            {expandedPosjednici ? (
              <ModelTable
                title=" "
                tableName="posjednici"
                viewName="default"
                records={recordsPosjednici || []}
                dc={dcPosjednici}
                allowSelection="none"
                allowAdd={false}
                allowRowAction={() => {
                  return false;
                }}
                // allowRowsPerPageSelection={false}
                onRowAction={() => {}}
                // smallButtons={true}
                disableControls
              />
            ) : null}
            {expandedVlasnici ? (
              <ModelTable
                title=" "
                tableName="vlasnici"
                viewName="default"
                records={recordsVlasnici || []}
                dc={dcVlasnici}
                allowSelection="none"
                allowAdd={false}
                allowRowAction={() => {
                  return false;
                }}
                // allowRowsPerPageSelection={false}
                onRowAction={() => {}}
                // smallButtons={true}
                disableControls
              />
            ) : null}
          </Collapse>
        ) : null}
      </MapCard>
    </Fragment>
  );
}

export default GSInfoCard;
